<template>
  <div @drop="dropme" @dragend="dragendme" @dragover="dragoverme">
    <ModalConfirm :showMe="showMe" @confirmed="modalResponse" />

    <section class="list" :id="list.list_id">
      <span class="delete-list">
        <i class="fas fa-trash" @click="deleteThisList"></i>
      </span>
      <span class="collapse-list">
        <i class="fas fa-angle-double-up" v-if="!collapseList" @click="collapseListHandler"></i>
        <i class="fas fa-angle-double-down" v-else @click="collapseListHandler"></i>
      </span>
      <span
        class="list-title"
        @click="editingName = !editingName"
        v-if="!editingName"
      >{{ editedName }}</span>
      <span class="list-name-editing" v-if="editingName">
        <input type="text" v-model="localName" @keydown="finishEditing" />
      </span>

      <NewItem :list="list" />
      <input
        v-if="list.items"
        type="text"
        name="filter-items"
        class="filter-items"
        placeholder="Type here to show only..."
        v-model="itemFilter"
      />
      <section v-show="!collapseList">
        <Item
          :id="item.item_id"
          @dragstart.native="dragstartme"
          @dragenter.native="dragenterme"
          @dragleave.native="dragleave"
          class="item-component"
          :class="list.list_id"
          v-for="item in filteredItems"
          :key="item.item_id"
          :item="item"
          @deleteMe="deleteFromFirebase(item)"
          @updateMe="updateItem"
          @updateMeImage="updateImageUrl"
          @updateMeDueDate="updateDueDate"
          @updateMeExternalLink="updateExternalLink"
          @updateListOrder="updateItemsFB"
          @doneItemToggle="updateItemBooleanFB"
          @specialItemToggle="updateItemBooleanFB"
          @setStatus="assignStatus"
        />
      </section>
    </section>
  </div>
</template>

<script>
import db from "@/fb/init";
import firebase from "firebase/app";
// eslint-disable-next-line
import auth from "firebase/auth";

import { EventBus } from "@/eventbus";

import Item from "@/components/Item";
import NewItem from "@/components/NewItem";
import ModalConfirm from "@/components/ModalConfirm";

export default {
  name: "List",
  components: {
    Item,
    NewItem,
    ModalConfirm
  },
  props: ["list"],
  data() {
    return {
      localName: null,
      editingName: false,
      items: [],
      targetId: null,
      draggedId: null,
      draggedIndex: null,
      showMe: false,
      itemFilter: null,
      collapseList: this.list.isCollapsed
      // placeholder: () => {
      //   const div = document.createElement("div");
      //   const text = document.createTextNode("");
      //   div.appendChild(text);
      //   div.style = "background-color:#000000;width:300px;height:136px;";
      //   return div;
      // },
      // currentList: null
    };
  },
  mounted() {
    db.collection("boards")
      .doc(this.list.board_id)
      .collection("lists")
      .doc(this.list.list_id)
      .onSnapshot(doc => {
        this.items = doc.get("items");
        EventBus.$emit("clearFlash");
      });

    // const name = this.getCollapseState(this.list.list_id);
    // if (window.localStorage.getItem(name)) {
    //   this.collapseList = window.localStorage.getItem(name);
    // }
  },
  computed: {
    editedName() {
      return this.localName || this.list.name;
    },

    filteredItems() {
      if (this.items) {
        return this.items.filter(it => {
          if (this.itemFilter) {
            return it.name
              .toLowerCase()
              .includes(this.itemFilter.toLowerCase());
          } else {
            return it;
          }
        });
      }
      return [];
    }
  },
  watch: {
    editingName() {
      this.localName = this.localName || this.editedName;
    },
    collapseList() {
      const listId = this.list.list_id;
      const name = "list-" + listId;
      if (this.collapseList) {
        window.localStorage.setItem(name, true);
      } else {
        window.localStorage.setItem(name, false);
      }
    }
  },
  methods: {
    /* ITEM FUNCTIONS  */

    collapseListHandler() {
      this.collapseList = !this.collapseList;
      this.updateCollapseList();
    },

    deleteItem(item) {
      db.collection("boards")
        .doc(this.list.board_id)
        .collection("lists")
        .doc(this.list.list_id)
        .update({
          items: firebase.firestore.FieldValue.arrayRemove(item)
        })
        .catch(err => {
          const messageObj = {
            message: err.message,
            status: "error",
            duration: 3000
          };
          EventBus.$emit("showFlash", messageObj);
        });
    },

    deleteItemFromBoard(item) {
      db.collection("boards")
        .doc(item.board_id)
        .update({
          itemsDue: firebase.firestore.FieldValue.arrayRemove(item.item_id)
        });
    },

    addToBoardItemsDue(item) {
      db.collection("boards")
        .doc(item.board_id)
        .update({
          itemsDue: firebase.firestore.FieldValue.arrayUnion(item.item_id)
        });
    },

    deleteFromFirebase(item) {
      EventBus.$emit("clearFlash");
      // check if item had expired due date
      if (item.dueDate) {
        const dueDate = new Date(item.dueDate);
        const now = new Date();
        const dueNow = dueDate <= now;
        // in case item might be orphaned in board.itemsDue, remove it
        if (dueNow) {
          this.deleteItemFromBoard(item);
        }
      }
      this.deleteItem(item);
    },

    deleteThisList() {
      this.showMe = true;
    },

    modalResponse(response) {
      if (response) {
        this.$emit("deleteList", this.list);
      }
      this.showMe = false;
    },

    updateCollapseList() {
      db.collection("boards")
        .doc(this.list.board_id)
        .collection("lists")
        .doc(this.list.list_id)
        .update({
          isCollapsed: this.collapseList
        });
    },

    updateItemsFB() {
      // console.log("In updateItemsFB");
      EventBus.$emit("clearFlash");
      db.collection("boards")
        .doc(this.list.board_id)
        .collection("lists")
        .doc(this.list.list_id)
        .update({
          items: this.items
        })
        .catch(err => {
          const messageObj = {
            message: err.message,
            status: "error",
            duration: 3000
          };
          EventBus.$emit("showFlash", messageObj);
        });
    },

    updateItem({ newName, item }) {
      EventBus.$emit("clearFlash");
      this.items.forEach(it => {
        if (it.item_id === item.item_id) {
          it.name = newName;
        }
      });
      this.updateItemsFB();
    },

    updateImageUrl({ newImageUrl, item }) {
      this.items.forEach(it => {
        if (it.item_id === item.item_id) {
          it.imageUrl = newImageUrl;
        }
      });
      this.updateItemsFB();
    },

    updateDueDate({ newDueDate, item }) {
      this.items.forEach(it => {
        if (it.item_id === item.item_id) {
          this.updateDueDatesFB(it, it.dueDate, newDueDate);
          it.dueDate = newDueDate;
        }
      });
      this.updateItemsFB();
    },

    updateExternalLink({ newExternalLink, item }) {
      this.items.forEach(it => {
        if (it.item_id === item.item_id) {
          it.externalLink = newExternalLink;
        }
      });
      this.updateItemsFB();
    },

    assignStatus({ item, choice }) {
      this.items.forEach(it => {
        if (it.item_id == item.item_id) {
          it.status = choice;
          if (choice === "finished") {
            it.done = true;
          }
        }
      });
      this.updateItemBooleanFB({ item });
    },

    updateItemBooleanFB({ item }) {
      /**Below needed b/c functions don't peer into object property arrays */
      // if item.done, remove from board.itemsDue
      if (item.done || item.status === "finished") {
        this.deleteItemFromBoard(item);
      } else {
        if (item.dueDate) {
          const dueDate = new Date(item.dueDate);
          const now = new Date();
          const dueNow = dueDate <= now;
          // if item NOT done, but expired, add to board.itemsDue
          if (!item.done && dueNow) {
            this.addToBoardItemsDue(item);
          }
        }
      }
      this.updateItemsFB();
    },

    updateDueDatesFB(item, oldDate, newDate) {
      let re = /\//g;
      let user = firebase.auth().currentUser;
      let email = user.email;
      if (item.dueDate) {
        const oldFormatted = oldDate.replace(re, "-");
        // remove from db
        db.collection("notification_dates")
          .doc(oldFormatted)
          .collection("items")
          .doc(item.item_id)
          .delete();
        // .catch(e => {
        //   window.console.error("Error deleting!", e);
        // });
      }
      if (newDate) {
        const newFormatted = newDate.replace(re, "-");
        // add to db
        db.collection("notification_dates")
          .doc(newFormatted)
          .collection("items")
          .doc(item.item_id)
          .set({
            email: email,
            board_id: this.list.board_id
          });
      }
    },

    // getCollapseState(id) {
    //   const name = "list-" + id;
    //   return name;
    // },

    /* LIST FUNCTION  */

    finishEditing(e) {
      EventBus.$emit("clearFlash");
      if (e.which === 27) {
        this.editingName = false;
      }
      if (e.which === 13) {
        db.collection("boards")
          .doc(this.list.board_id)
          .collection("lists")
          .doc(this.list.list_id)
          .update({
            name: this.localName
          })
          .then(() => (this.editingName = false))
          .catch(err => {
            const messageObj = {
              message: err.message,
              status: "error",
              duration: 3000
            };
            EventBus.$emit("showFlash", messageObj);
          });
      }
    },

    /******************** DRAG AND DROP FUNCTIONS *******************************/
    dragstartme(e) {
      const itemId = e.target.id;
      const item = this.items.find(it => it.item_id === itemId);
      // window.console.log("start item", itemId);
      window.localStorage.setItem("item", JSON.stringify(item));
      e.dataTransfer.setData("text", itemId);
      // window.console.log(e.target.parentNode);
      // this.currentList = e.target.parentNode;
    },
    dragoverme(e) {
      e.preventDefault();
      e.stopPropagation();
      // window.console.log("dragover:  e.target", e.target);
      // e.dataTransfer.getData("text", itemId);
    },
    dragenterme(e) {
      e.preventDefault();
      e.stopPropagation();
      // window.console.log("dragenter target", e.target);
      if (!e.target.src && e.target.classList[0] === "item-text") {
        e.target.style.opacity = 0.25;
        // window.console.log(e.target.classList[0] === "item-text");
        // if (e.target.parentNode.parentNode.classList[0] === "list") {
        //   // this.currentList = e.target.parentNode.parentNode;
        //   // window.console.log(e.target.parentNode.parentNode);
        //   // window.console.log(this.placeholder());
        //   // window.console.log(e.target.parentNode);
        //   this.currentList.insertBefore(
        //     this.placeholder(),
        //     e.target.parentNode
        //   );
        // }
      } // else {
      //   e.target.style.cursor = "not-allowed";
      // }
    },
    dragleave(e) {
      e.preventDefault();
      e.stopPropagation();
      e.target.style.opacity = 1;
      // if (e.target.parentNode.parentNode.classList[0] === "list") {
      // window.console.log(e.target.parentNode.parentNode);
      // this.currentList.removeChild(this.placeholder());
      // }
    },
    dropme(e) {
      e.preventDefault();
      e.stopPropagation();
      e.target.style.opacity = 1;

      // window.console.log("drop e.target", e.target);
      // window.console.log("drop e.target.parentNode", e.target.parentNode);

      // const newListId = e.target.classList[2];
      const newListId = e.target.parentNode.classList[2];
      // const newId = e.target.parentNode.id;
      const originalItem = JSON.parse(window.localStorage.getItem("item"));

      if (newListId) {
        // moving to populated list
        const startSourceId = e.dataTransfer.getData("text", e.target.id);
        // const endTargetId = e.target.id;
        const endTargetId = e.target.parentNode.id;

        if (startSourceId === endTargetId) {
          return;
        }
        const startIndex = this.items.findIndex(it => {
          return it.item_id === startSourceId;
        });

        if (startIndex >= 0) {
          this.moveToLocalList(startIndex, endTargetId);
        } else {
          this.moveToNewList(newListId);
        }
      } else {
        // moving to empty list
        const newListId = e.target.id;
        // window.console.log("newListId", newListId);

        // make sure list_id is different before trying anything
        if (newListId !== originalItem.list_id) {
          this.moveToNewList(newListId);
        }
      }
    },
    dragendme(e) {
      e.preventDefault();
    },
    moveToLocalList(startIndex, endTargetId) {
      const targetIndex = this.items.findIndex(it => {
        return it.item_id === endTargetId;
      });

      if (targetIndex >= 0) {
        this.items = this.reorderArray(startIndex, targetIndex, this.items);
        this.updateItemsFB();
      }
    },
    moveToNewList(newListId) {
      this.$emit("insertIntoDifferentList", newListId);
    },
    reorderArray(oldIndex, newIndex, originalArray) {
      const movedItem = originalArray.filter(
        (item, index) => index === oldIndex
      );
      const remainingItems = originalArray.filter(
        (item, index) => index !== oldIndex
      );
      const reorderedItems = [
        ...remainingItems.slice(0, newIndex),
        movedItem[0],
        ...remainingItems.slice(newIndex)
      ];
      return reorderedItems;
    }
  }
};
</script>
